import React from 'react';
import { Outlet } from 'react-router-dom';
import { BottomNavigation } from './Navigation';

// Mobile Layout - بدون header أو sidebar
// يعرض المحتوى مع الشريط السفلي الثابت في جميع الصفحات
const MobileLayout = () => {
  return (
    <div className="min-h-screen pb-20">
      <Outlet />
      {/* الشريط السفلي ثابت في جميع الصفحات */}
      <BottomNavigation />
    </div>
  );
};

export default MobileLayout;
